import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PATH_FOR_YM_PARAMS } from "./locationsYmParams";
import { isSSR } from "./device";
export var ymPushEvent = function ymPushEvent() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 26001372;
  if (isSSR() || !window.ym) return;
  window.ym(id, 'reachGoal', key, payload);
};
export var ymPushWithUrl = function ymPushWithUrl() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isSSR()) return;
  ymPushEvent(key, _objectSpread({
    URL: document.location.href
  }, payload));
};
export var ymPushParams = function ymPushParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (isSSR() || !window.ym) return;
  window.ym(26001372, 'params', payload);
};
export var ymSetParams = function ymSetParams(params) {
  var path = window.location.pathname.replace(/\/?$/, '/');
  if (Object.values(PATH_FOR_YM_PARAMS).includes(path)) {
    ymPushParams(params);
  }
};
export var sendCallbackSuccessDataAnalitics = function sendCallbackSuccessDataAnalitics() {
  ymPushEvent('HomeTariffCallbackMainPage', {
    form_type: 'main',
    URL: window.location.href
  });
};

// TODO: возможно неактуальная аналитика, уточнить
export var sendConnectionQuestionsPhoneClickAnalytics = function sendConnectionQuestionsPhoneClickAnalytics() {
  ymPushParams({
    fttb_page_ev_: {
      phone_click: 'call_back_form'
    }
  });
  ymPushEvent('HomeTariffPhoneClick');
};